import React, { useEffect, useState } from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import style from './MissionCountDown.scss';

export const MissionCountDown = ({ campaignEndTime, startTime, endTime, status }) => {
    const t = usePortletTranslations();

    const getValue = () => {
        if (status === 'IN_DESIGN' || status === 'APPROVED') {
            return new Date(startTime).getTime();
        } else if (status === 'ACTIVE') {
            return new Date(endTime).getTime();
        }
    };

    const isDataSame = () => {
        return status === 'ACTIVE' && campaignEndTime === endTime;
    };

    const isDataTheSame = isDataSame();

    const countDownDate = getValue() - new Date().getTime();

    const [countDown, setCountDown] = useState(countDownDate >= 0 ? countDownDate : 0);

    useEffect(() => {
        const interval = setInterval(() => {
            const diff = getValue() - new Date().getTime();
            if (diff >= 0) {
                setCountDown(diff);
            }
        }, 1000);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [countDownDate]);
    const formatData = (millis) => {
        const days = Math.floor(millis / 1000 / 60 / 60 / 24);
        const hours = Math.floor(millis / 1000 / 60 / 60) % 24;
        const minutes = Math.floor(millis / 1000.0 / 60) % 60;
        const seconds = Math.floor(millis / 1000.0) % 60;
        if (days > 0) {
            return t('countDown.timeTillEnd.dd_hh_mm')
                .replace('{0}', days)
                .replace('{1}', hours > 9 ? hours : `0${hours}`)
                .replace('{2}', minutes > 9 ? minutes : `0${minutes}`);
        } else if (hours > 0) {
            return t('countDown.timeTillEnd.hh_mm')
                .replace('{0}', hours > 9 ? hours : `0${hours}`)
                .replace('{1}', minutes > 9 ? minutes : `0${minutes}`);
        }
        return t('countDown.timeTillEnd.mm_ss')
                .replace('{0}', minutes > 9 ? minutes : `0${minutes}`)
                .replace('{1}', seconds > 9 ? seconds : `0${seconds}`);

    };
    return (
        <div className={style.wrapper}>
            {!isDataTheSame &&
            <div className={style.title}>{status === 'IN_DESIGN' || status === 'APPROVED' ?
                t('countDown.mode.start') : t('countDown.mode.end')}</div>}
            {!isDataTheSame && <div className={style.value}>{formatData(countDown)}</div>}
        </div>
    );
};
